module.exports = __webpack_public_path__ + "static/hourly_car_service-e85ba86583bc0f793347b544d21fc452.jpg";